import { HttpClientModule } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import {
  browserLocalPersistence,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth,
  provideAuth,
} from '@angular/fire/auth';
import { initializeFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { Capacitor } from '@capacitor/core';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { CalendarModule as IonCalendarModule } from 'ion7-calendar';
import {
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
} from 'ng-recaptcha-2';

import { environment } from '../environments/environment';
import { routes } from './app.routes';

export const firebaseConfig = environment.firebaseConfig;

const isNativePlatform = Capacitor.isNativePlatform();
const serviceWorkerSupported =
  typeof navigator !== 'undefined' &&
  'serviceWorker' in navigator &&
  !!navigator.serviceWorker;

console.log(
  'FlaggerAI central Firebase project:',
  firebaseConfig?.projectId || ''
);
console.log('Capacitor native:', isNativePlatform);
console.log('Service worker supported:', serviceWorkerSupported);

if (isNativePlatform) {
  console.log('App Check web provider not initialized on native Capacitor.');
}

function initializeCentralAuth() {
  const app = getApp();

  try {
    const auth = initializeAuth(app, {
      persistence: [indexedDBLocalPersistence, browserLocalPersistence],
    });

    console.log('[firebase auth] initialized explicit persistence', {
      projectId: app.options.projectId,
      native: isNativePlatform,
      persistence: ['indexedDBLocalPersistence', 'browserLocalPersistence'],
    });

    return auth;
  } catch (error: any) {
    console.warn('[firebase auth] using existing auth instance', {
      projectId: app.options.projectId,
      native: isNativePlatform,
      code: error?.code,
      message: error?.message,
    });

    return getAuth(app);
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha.siteKey,
      } as RecaptchaSettings,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    importProvidersFrom(
      IonicModule.forRoot({}),
      HttpClientModule,
      IonCalendarModule.forRoot()
    ),
    provideFirebaseApp(() => initializeApp(firebaseConfig)),
    provideAuth(() => initializeCentralAuth()),
    provideFirestore(() =>
      initializeFirestore(getApp(), {
        experimentalForceLongPolling: true,
      })
    ),
    provideStorage(() => getStorage(getApp())),
    provideFunctions(() => {
      const app = getApp();

      console.log('[firebase functions] initialized', {
        projectId: app.options.projectId,
        region: 'us-central1',
        native: isNativePlatform,
      });

      return getFunctions(app, 'us-central1');
    }),
    provideRouter(routes),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode() && !isNativePlatform && serviceWorkerSupported,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
